import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';
import { NotificationType } from '../../../../../../shared/IFE/components/notification/notification.component';

@Component({
  selector: 'evc-quote-personal-details-contact-details',
  providers: [createProvider(ContactDetailsComponent)],
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactDetailsComponent extends Step implements OnInit {
  readonly formName = 'evcQuote';
  readonly stepName = 'personal-details-contact-details';
  readonly notificationType = NotificationType;
  alteredAddress: string;

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  setAddress(address): void {
    const zipCode = address.address_components.find((el) => el.types.includes('postal_code'));
    const houseNumber = address.address_components.find((el) => el.types.includes('street_number'));
    const route = address.address_components.find((el) => el.types.includes('route'));
    const locality = address.address_components.find((el) => el.types.includes('locality'));
    this.alteredAddress = zipCode
      ? `${route.long_name}, ${zipCode.long_name} ${locality.long_name}`
      : `${route.long_name}, ${locality.long_name}`;
    this.control.patchValue(
      {
        fullAddress: this.alteredAddress,
        houseNumber: houseNumber ? houseNumber.long_name : '',
      },
      { emitEvent: true }
    );
  }

  isFormGroupInvalid(): boolean {
    // We display the error notification only when all controls are touched and invalid
    for (const field in this.control.controls) {
      if ((this.control.get(field).touched || this.control.get(field).dirty) && this.control.get(field).invalid) {
        return true;
      }
    }
  }

  public navigate(): void {
    if (this.control.valid) {
      this.onTouch();
      this.valueChanges(this.control.value);
    }
    super.navigate();
  }

  protected buildForm() {
    this.control = this.fb.group({
      name: this.fb.control('', [Validators.required]),
      surname: this.fb.control('', [Validators.required]),
      phoneNumber: this.fb.control('', [Validators.required, Validators.pattern('[(+)0-9]{9,13}')]),
      fullAddress: this.fb.control('', [Validators.required]),
      houseNumber: this.fb.control('', [Validators.required]),
      mailbox: this.fb.control(''),
      company: this.fb.control(''),
      vatNumber: this.fb.control(''),
    });
  }
}
